import {DialogController} from 'aurelia-dialog';
import {inject} from "aurelia-framework";

@inject(DialogController)
export class RemoveTagView {
    constructor(dialogController) {
        this.dialogController = dialogController;
    }

    async activate(context) {
        this.title   = context.title;
        this.onSave  = context.onSave;
        this.loading = false;

        this.tags = [...new Set(
            (context.items ?? []).flatMap(item => item.tags ?? [])
        )].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

        this.selectedTags = [];
        this.noTags = this.tags.length === 0;
    }

    async ok() {
        if (this.selectedTags.length === 0) return;

        this.loading = true;

        return this.onSave(this.selectedTags).then(() => {
            return Promise.resolve(this.dialogController.ok());
        }).catch((error) => {
            this.loading = false;
            throw error;
        });
    }
}
